import { render } from "./InfraServiceLogo.vue?vue&type=template&id=67a58610&scoped=true"
import script from "./InfraServiceLogo.vue?vue&type=script&lang=js"
export * from "./InfraServiceLogo.vue?vue&type=script&lang=js"

import "./InfraServiceLogo.vue?vue&type=style&index=0&id=67a58610&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a58610"]])

export default __exports__